module.exports = __webpack_public_path__ + "img/uncheck.881094f6.svg";